import { Pipe, PipeTransform } from '@angular/core';
import { IPrice, IRetail } from "libraries/interfaces/watabilight/IWatabiLightBooking.interface";

@Pipe({
    name: 'isIdenticalPrices'
})
export class IsIdenticalPricesPipe implements PipeTransform {
   public transform(quotePrices: IPrice): boolean {
       console.log({quotePrices})
        return quotePrices?.retailAgency?.total?.value === quotePrices.retail?.total?.value;
    }
}
